import EditIcon from '@mui/icons-material/Edit';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import * as React from 'react';
import { INBOX_FILTER_INITIAL_STATE } from '../../../sic-lib/defaults';
import { InboxFilter } from '../../../sic-lib/types/InboxTypes';
import { useAppDispatch } from '../../../store/hooks';
import { setFilters } from '../../../store/inbox';

interface Props {
    userDefaultFilter: InboxFilter | undefined;
    openDropDownMenu: boolean;
    anchorEl: HTMLElement | null;
    setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
    setShowFilterDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    setShowSavedFiltersDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}

const FilterDropDown = ({
    userDefaultFilter,
    openDropDownMenu,
    anchorEl,
    setAnchorEl,
    setShowFilterDrawer,
    setShowSavedFiltersDrawer,
}: Props) => {
    const dispatch = useAppDispatch();

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEditFilterSelect = () => {
        setShowFilterDrawer(true);
        handleClose();
    };

    const handleViewSavedFiltersSelect = () => {
        setShowSavedFiltersDrawer(true);
        handleClose();
    };

    const handleRestoreMyDefaultSelect = () => {
        dispatch(setFilters({ filter: userDefaultFilter || INBOX_FILTER_INITIAL_STATE }));
        handleClose();
    };

    const handleClearFilterSelect = () => {
        dispatch(setFilters({ filter: INBOX_FILTER_INITIAL_STATE }));
        handleClose();
    };

    return (
        <Menu
            id="dropdown-menu"
            aria-labelledby="dropdown-button"
            anchorEl={anchorEl}
            open={openDropDownMenu}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <MenuItem onClick={handleEditFilterSelect}>
                <ListItemIcon>
                    <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit Filter</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleViewSavedFiltersSelect}>
                <ListItemIcon>
                    <StarOutlineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>View Saved Filters</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleRestoreMyDefaultSelect}>
                <ListItemIcon>
                    <StarIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Restore My Default</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleClearFilterSelect}>
                <ListItemIcon>
                    <FilterAltOffIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Clear Filter</ListItemText>
            </MenuItem>
        </Menu>
    );
};

export default FilterDropDown;
